import React from 'react';
import { useApp } from '../../contexts/AppContext';
import { ContentCard } from './ContentCard';
import './ContentList.css';

export const ContentList: React.FC = () => {
  const { currentSection, currentContent, loading, addContent } = useApp();

  if (!currentSection) {
    return (
      <div className="content-container">
        <div className="content-header">
          <h2>Welcome</h2>
          <p>Select a section from the left to manage its content</p>
        </div>
        <div className="content-body">
          <div className="empty-state">
            <h3>No Section Selected</h3>
            <p>Choose a section from the book tree to start managing content</p>
          </div>
        </div>
      </div>
    );
  }

  const handleAddContent = async () => {
    await addContent({
      title: 'New Content',
      content_text: '<p>Enter your content here...</p>'
    });
  };

  return (
    <div className="content-container">
      <div className="content-header">
        <h2>{currentSection.title}</h2>
        <p>Manage content for this section</p>
      </div>
      <div className="content-body">
        {loading ? (
          <div className="loading">Loading content...</div>
        ) : currentContent.length === 0 ? (
          <div className="empty-state">
            <h3>No Content Yet</h3>
            <p>This section doesn't have any content</p>
            <button 
              className="btn btn-primary" 
              style={{ marginTop: '16px' }}
              onClick={handleAddContent}
            >
              Add First Content
            </button>
          </div>
        ) : (
          <>
            <button 
              className="btn btn-success" 
              style={{ marginBottom: '16px' }}
              onClick={handleAddContent}
            >
              + Add Content
            </button>
            <div className="content-list">
              {currentContent.map((content, index) => (
                <ContentCard 
                  key={content.id} 
                  content={content} 
                  index={index}
                  isFirst={index === 0}
                  isLast={index === currentContent.length - 1}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};